// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap__Yk9N6"};